import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export const generarCertificadoPDF = async (datos) => {
  const { nombreUsuario, dni, nombreCurso, fecha, empresa } = datos;

  // Crear un elemento HTML temporal para el certificado
  const certificateHtml = `
    <div id="certificate-template" style="
      width: 842px; 
      height: 595px; 
      padding: 40px; 
      background: white; 
      font-family: 'Arial', sans-serif;
      position: relative;
      border: 15px solid #1a237e;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
    ">
      <div style="
        position: absolute;
        top: 20px;
        bottom: 20px;
        left: 20px;
        right: 20px;
        border: 2px solid #c5a059;
        pointer-events: none;
      "></div>

      <div style="margin-bottom: 20px;">
        <h3 style="color: #1a237e; margin: 0; text-transform: uppercase; letter-spacing: 5px; font-size: 24px;">Certificado</h3>
        <h4 style="color: #c5a059; margin: 5px 0 0 0; text-transform: uppercase; letter-spacing: 2px; font-size: 16px;">de Finalización</h4>
      </div>

      <p style="font-size: 18px; color: #555; margin: 20px 0;">Este documento certifica que</p>

      <h1 style="font-size: 42px; color: #1a237e; margin: 10px 0; font-family: 'Times New Roman', serif;">${nombreUsuario}</h1>
      <p style="font-size: 16px; color: #777; margin: 0;">DNI: ${dni}</p>

      <p style="font-size: 18px; color: #555; margin: 30px 0;">Ha completado satisfactoriamente el curso de capacitación:</p>

      <h2 style="font-size: 28px; color: #1a237e; margin: 10px 0;">${nombreCurso}</h2>

      <div style="margin-top: 50px; width: 80%; display: flex; justify-content: space-between; align-items: flex-end;">
        <div style="text-align: center; width: 200px;">
          <div style="border-top: 1px solid #333; padding-top: 10px;">
            <p style="margin: 0; font-size: 14px; font-weight: bold;">${empresa || "La Empresa"}</p>
            <p style="margin: 0; font-size: 12px; color: #777;">Emisor Autorizado</p>
          </div>
        </div>
        
        <div style="text-align: center; width: 200px;">
          <p style="margin: 0 0 10px 0; font-size: 14px; font-weight: bold; color: #1a237e;">${fecha}</p>
          <div style="border-top: 1px solid #333; padding-top: 10px;">
            <p style="margin: 0; font-size: 12px; color: #777;">Fecha de Emisión</p>
          </div>
        </div>
      </div>

      <div style="position: absolute; bottom: 30px; right: 40px; opacity: 0.1;">
        <img src="https://via.placeholder.com/100" alt="seal" style="width: 100px; height: 100px;" />
      </div>
    </div>
  `;

  // Crear un contenedor invisible
  const container = document.createElement("div");
  container.style.position = "absolute";
  container.style.left = "-9999px";
  container.style.top = "-9999px";
  container.innerHTML = certificateHtml;
  document.body.appendChild(container);

  try {
    const canvas = await html2canvas(container.querySelector("#certificate-template"), {
      scale: 2,
      useCORS: true,
      logging: false,
    });

    document.body.removeChild(container);

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF({
      orientation: "landscape",
      unit: "px",
      format: [842, 595],
    });

    pdf.addImage(imgData, "PNG", 0, 0, 842, 595);
    pdf.save(`Certificado_${nombreCurso.replace(/ /g, "_")}_${dni}.pdf`);
  } catch (error) {
    console.error("Error al generar el certificado PDF:", error);
    if (container.parentNode) document.body.removeChild(container);
    throw error;
  }
};
